export const PasswordField = () => {
  const passwordFieldElements = document.querySelectorAll('.js-password');

  passwordFieldElements.forEach(el => {
    const field = el.querySelector('input');
    const iconEye = el.querySelector('.js-eye');
    const iconEyeClosed = el.querySelector('.js-eye-closed');

    iconEye.addEventListener('click', () => {
      iconEyeClosed.classList.remove('hidden');
      iconEye.classList.add('hidden');
      field.type = 'text';
    });

    iconEyeClosed.addEventListener('click', () => {
      iconEye.classList.remove('hidden');
      iconEyeClosed.classList.add('hidden');
      field.type = 'password';
    });
  });
};
